import{m as t}from"./chunk-HBP5N4FR.js";t();import{useState as c,useEffect as f}from"react";var p=(e,n)=>{let[o,r]=c(e);return f(()=>{let s=setTimeout(()=>r(e),n);return()=>clearTimeout(s)},[e]),o};export{p as a};
//# sourceMappingURL=chunk-VPGECZPA.js.map
